// extracted by css-extract-rspack-plugin
export default {"content":"K85d2"};